import { Container } from './LoginRestricted.styles';
import AppLogo from '@assets/logos/swise_black_on_white.svg';
import { Flex, Text } from '@components';
import { Link } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactNode } from 'react';

export enum LoginRestrictedError {
  Terminated = 'ACCOUNT HAS BEEN TERMINATED',
  Suspended = 'ACCOUNT HAS BEEN SUSPENDED',
}

interface LoginRestrictedProps {
  type: LoginRestrictedError;
}

const LoginRestricted = ({ type: _type }: LoginRestrictedProps) => {
  return (
    <Container>
      <Flex mb={12}>
        <img alt='logo' width='140' height='50' src={AppLogo} />
      </Flex>
      <Flex width='50%' flexDirection='column' gap={16}>
        <Text variant='h3' fontWeight='fontWeightBold'>
          <FormattedMessage id={`restrictedLogin.suspended.title`} />
        </Text>
        <Text variant='h5' fontWeight='fontWeightMedium' textAlign='justify'>
          <FormattedMessage
            id={`restrictedLogin.suspended.subtitle`}
            values={{
              email: (chunks: ReactNode[]): ReactNode => (
                <Link href={`mailto:${chunks}`}>{chunks}</Link>
              ),
              br: (
                <>
                  <br />
                  <br />
                </>
              ),
            }}
          />
        </Text>
      </Flex>
    </Container>
  );
};

export default LoginRestricted;
